/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekRequest,
  FacilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekResultDto
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getCopyWeek = () => {
/**
 * @summary Copies the planned tasks of an ISO week to the same weekdays of the target week. Tasks
already planned that day are not duplicated; holidays, absences and free days are
skipped and reported, as are tasks whose schedule rule is not due in the target week
(`planning.copyWeek.notDue`). Body optional: `employeeIds` limits the copy.
 */
const postApiV1PlanningWeeksYearWeekCopyToTargetYearTargetWeek = (
    year: number,
    week: number,
    targetYear: number,
    targetWeek: number,
    facilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekRequest: FacilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekResultDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekResultDto>(
      {url: `/api/v1/planning/weeks/${year}/${week}/copy-to/${targetYear}/${targetWeek}`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosCopyWeekCopyWeekRequest
    },
      options);
    }
  return {postApiV1PlanningWeeksYearWeekCopyToTargetYearTargetWeek}};
export type PostApiV1PlanningWeeksYearWeekCopyToTargetYearTargetWeekResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getCopyWeek>['postApiV1PlanningWeeksYearWeekCopyToTargetYearTargetWeek']>>>
